import { render, staticRenderFns } from "./w-preferred-partners.vue?vue&type=template&id=4b22961a"
import script from "./w-preferred-partners.vue?vue&type=script&lang=js"
export * from "./w-preferred-partners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports